import ResizeTracker from 'utils/ResizeTracker';

const _handleResize = () => {
    // eslint-disable-next-line no-magic-numbers
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export const setViewportHeight = () => {

    const resizeTracker = new ResizeTracker();

    resizeTracker.init(
        { element: document.documentElement },
        _handleResize
    );

    _handleResize();
};
